import { pollRequest } from './pollRequest';

type PollUntilCompletedOptions = {
  url: string;
  initialInterval?: number;
  maxInterval?: number;
  backoffFactor?: number;
  maxAttempts?: number;
};

const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const pollUntilCompleted = async ({
  url,
  initialInterval = 1000,
  maxInterval = 8000,
  backoffFactor = 1.5,
  maxAttempts = 120,
}: PollUntilCompletedOptions) => {
  let pollingResult;
  let attempts = 0;
  let currentInterval = initialInterval;

  do {
    // eslint-disable-next-line no-await-in-loop
    await sleep(currentInterval);
    // eslint-disable-next-line no-await-in-loop
    pollingResult = await pollRequest(url);
    attempts++;
    currentInterval = Math.min(currentInterval * backoffFactor, maxInterval);
  } while (
    attempts < maxAttempts &&
    pollingResult.response.status !== 'COMPLETED' &&
    pollingResult.response.status !== 'FAILED'
  );

  if (pollingResult.response.status === 'FAILED') {
    throw new Error('Workflow execution failed');
  }

  if (
    attempts >= maxAttempts &&
    pollingResult.response.status !== 'COMPLETED'
  ) {
    throw new Error('Polling timeout: Maximum attempts reached');
  }

  return pollingResult;
};

export { pollUntilCompleted };
